module.exports = __webpack_public_path__ + "./fonts/icomoon.a86689.eot";